import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



export default function DGLTH_pdc_badge({ item, entity = null}) {


    return (
        <>
            {(item.badge === 0) ?
            <FontAwesomeIcon icon="circle" color="red" size="lg" /> : <></>}
            {(item.badge === 1) ?
            <FontAwesomeIcon icon="circle" color="green" size="lg" /> : <></>}
            {(item.badge === null) ?
            <FontAwesomeIcon icon="circle" color="#000000" size="lg" /> : <></>}
        </>
    )
};